<template>
  <div class="fabric-info__container">
    <div class="fabric-info__wrapper d-flex">
      <div class="fabric-img__wrapper">
        <el-image
          :src="
            formData.defaultImageUrl
              ? $osscdn(formData.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            formData.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          class="fabric-img"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" class="fabric-img" />
          </div>
        </el-image>
        <div class="operate-button__wrapper edit">
          <i class="button-icon el-icon-delete red" @click="delFabric"></i>
        </div>
      </div>

      <div class="fabric-detail__wrapper">
        <el-form
          ref="form"
          :model="formData"
          :disabled="disabled"
          :rules="rules"
          size="mini"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                :label="
                  $l('INDEX.evg_sku_label_fabricPositionCode') || '面料位置'
                "
                prop="fabricPositionCode"
              >
                <dict-select
                  clearable
                  filterable
                  size="mini"
                  v-model="formData.fabricPositionCode"
                  :selectedLabel.sync="formData.fabricPositionName"
                  :body="{ dictType: 'fabricPosition' }"
                  :disabled="disabled"
                  url="/master/common/dict/biz"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="
                  $l('INDEX.evg_sku_label_fabricColorTitle1') || '面料颜色'
                "
                prop="fabricColorTitle"
              >
                <el-input
                  v-model="formData.fabricColorTitle"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  readonly
                  maxlength="200"
                  clearable
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_fabricName') || '面料名称'"
                prop="fabricName"
              >
                <el-input
                  v-model="formData.fabricName"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  readonly
                  maxlength="200"
                  clearable
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_fabricContent') || '面料成分'"
                prop="fabricContent"
              >
                <el-input
                  v-model="formData.fabricContent"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  readonly
                  maxlength="200"
                  clearable
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    item: {
      handler() {
        this.formData = { ...this.item }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      formData: {},
      rules: {
        fabricPositionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        fabricColorNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        fabricName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        fabricColorTitle: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        fabricContent: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  methods: {
    delFabric() {
      this.$emit('delFabric')
    },
        async validateForm() {
      const result = await validate.formValidate([this.$refs.form])
      return result
    },
        getFabricData() {
      return this.formData
    },
  },
}
</script>
<style lang="scss" scoped>
.fabric-info__container {
  margin-top: 10px;
  border-radius: 5px;
  background-color: #f4f6f9;
  color: #101010;
  padding: 15px 15px;
  .fabric-img__wrapper {
    .operate-button__wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      > i {
        font-size: 20px;
        margin-left: 15px;
      }
      i:last-child {
        margin-right: 15px;
      }
      .red {
        color: #fa5c7c;
      }
    }
    .operate-button__wrapper.edit {
      justify-content: center;
    }
    .fabric-img {
      width: 117px;
      height: 77px;
      border: 1px solid #e8e8e8;
      border-radius: 3px;
      margin-bottom: 15px;
      > img {
        width: 117px;
        height: 77px;
        border-radius: 3px;
      }
    }
    > img {
      width: 96px;
      height: 96px;
      border-radius: 3px;
    }
  }

  .fabric-detail__wrapper {
    flex: 1;
    margin-left: 15px;
    .modify-info {
      display: flex;
      align-items: flex-end;
      color: #8e8e8e;
      font-size: 14px;
    }
  }
}
::v-deep {
  .fabric-detail__wrapper {
    .el-form-item__label {
      line-height: 30px !important;
    }
    .el-form-item {
      margin-bottom: 8px !important;
    }
  }
  .el-input-group__append {
    background-color: #a4adb3;
  }
}
.input-append__button {
  cursor: pointer;
  background-color: #a4adb3;
  color: white;
}
.button-icon {
  cursor: pointer;
}
</style>
